<template lang="pug">
  header.resume.standard
    section.avatar
      img( src='/me.jpg' )
      h1 Jovi Heng
      h2 JAMstack PWA Developer
    
    divider.on-dark

    section.contact
      .items
        combo-link.vertical.email.item.on-medium( to='mailto:jovi@diginomix.co' )
          template( v-slot:icon )
            email-icon
          template( v-slot:text ) Email
        //- a.email.item( href='mailto:jovi@diginomix.co' )
        //-   .icon
        //-     email-icon
        //-   .text Email
        
        combo-link.vertical.slack.item.on-medium( to='https://diginomix.slack.com' )
          template( v-slot:icon )
            slack-icon
          template( v-slot:text ) Slack
        //- router-link.slack.item( :to='{ name: "blog" }' )
        //-   .icon
        //-     blog-icon
        //-   .text( href='https://diginomix.slack.com' ) Blog

        //- a.blog.item( href='' )
        //-   .icon
        //-     codepen-icon
        //-   .text CodePen

        //- .location.item
        //-   span.icon
        //-     location-icon
        //-   span Planet Earth

    divider.on-dark

    section.skills
      h2.section Skills
      .gauges
        .js.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='9'
            :min='0'
            :max='10'
            :scale-interval='0.1'
          )
          .name JavaScript

        .css.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='10'
            :min='0'
            :max='10'
            :scale-interval='0.1'
          )
          .name CSS 3

        .html.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='10'
            :min='0'
            :max='10'
            :scale-interval='0.1'
          )
          .name HTML 5

        .vue.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='9'
            :min='0'
            :max='10'
            :scale-interval='0.1'
          )
          .name VueJS

        .firebase.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='9'
            :min='0'
            :max='10'
            :scale-interval='0.1'
          )
          .name Firebase

        .dev-ops.skill
          vue-svg-gauge.gauge(
            :base-color='gauge.background.color'
            :gauge-color='gauge.color'
            :start-angle='-110'
            :end-angle='110'
            :value='7'
            :min='0'
            :max='10'
            :scale-interval='1'
          )
          .name Dev Ops

    divider.on-dark

    section.education
      h2 Education
      //- divider.card
      .degree
        p.name University of California, Berkeley
        p.major  Computer Science, Cognitive Science 
        p.year Bachelor's (2003)

      //- divider.card

      //- .degree
      //-   p.name Michigan Institute of Technology
      //-   p.major Computational Science and Engineering
      //-   p.year Ph.D (2007)

      //- divider.card
</template>

<script>
  import { VueSvgGauge } from 'vue-svg-gauge'
  import Flex from '@/components/containers/flex'
  import Wrapper from '@/components/containers/wrapper'
  import SlackIcon from "vue-material-design-icons/Slack"
  import Divider from '@/components/containers/divider'
  import BlogIcon from 'vue-material-design-icons/PlaylistEdit'
  import CodepenIcon from 'vue-material-design-icons/Codepen'
  import ComboLink from '@/components/links/combo'
  import SkillsIcon from 'vue-material-design-icons/LaptopWindows'

  export default {
    name: 'standard.resume.header',

    components: {
      Flex,
      Wrapper,
      SlackIcon,
      Divider,
      VueSvgGauge,
      BlogIcon,
      CodepenIcon,
      VueSvgGauge,
      ComboLink,
      SkillsIcon
    },

    data() {
      return {
        gauge: { color: 'rgb( 192 192 192', background: { color: 'rgb( 96 96 96 )' } },
      }
    }
  }
</script>

<style lang="stylus" scoped>
  a
    text-decoration none
    color inherit
    cursor pointer
  
  h2
    margin-bottom 32px
    
  header
    --orange rgb( 162 124 96 )
    --blue rgb( 100 192 225 )
    --white rgb( 216 216 216 )
    --black rgb( 64 64 64 )
    --gray rgb( 188 188 188 )

    color rgb( 200 200 200 )
    display flex
    flex-direction column
    background rgba( 56 64 72 1 )
    box-shadow 0 0 16px rgba( 0 0 0 .75 )

    section
      font-size 1.1em
      line-height 1.5
    
    .avatar
      display flex
      align-items center
      justify-content center
      flex-direction column
      padding 64px 16px
      img
        display block
        border-radius 50%
        width 160px
        height 160px
        object-fit cover
        object-position top
        border 3px solid rgb( 144 144 144 )
        box-shadow 0 0 32px rgba( 0 0 0 .25 )
      h1 
        font-size 2.4em
        margin 8px 0
        text-align center
      h2
        text-align center
        font-size 1.2em
        color var( --blue )

    .contact
      display flex
      justify-content center
      font-size .88em

    .items
      display grid
      grid-template-columns 1fr 1fr
      grid-template-columns 50% 50%
      width 100%
      @media( max-width: 960px )
        max-width 360px

      .item
        display flex
        align-items center
        justify-content center
        flex-direction column
        padding 16px

      .icon
        // font-size 2.4em
      .text
        // font-size .75em
    
    .skills
      padding 32px 56px
      padding-bottom 64px
      display flex
      justify-content center
      align-items center
      flex-direction column
      h2
        font-size 1.25em
        grid-column 1 / -1
        text-align center

      .gauges
        display grid
        grid-template-columns 1fr 1fr
        grid-auto-rows 96px
        grid-gap 48px
        max-width 240px
      .skill
        text-align center
        line-height 0
        .name
          font-size .8em

    .education
      text-align center
      padding 32px 16px
      h1
        font-size 1.25em
        margin-bottom 8px
        padding-bottom 8px
      p
        font-size .92em
        line-height 1.75
      .name
        font-style italic
  </style>